module.exports = __webpack_public_path__ + "static/img/tijian-house.11aedbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tijian-house.png
// module id = E2Hk
// module chunks = 8